"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
const react_1 = require("react");
const useSearch = (requestServiceImp, initOptions, onError, source) => {
    const [selectableOptions, setSelectableOptions] = (0, react_1.useState)(initOptions);
    const search = async (searchString) => {
        try {
            const response = await requestServiceImp(searchString, source);
            setSelectableOptions(response.map((option) => ({
                ...option,
                id: option.value,
            })));
        }
        catch (error) {
            onError(error);
        }
    };
    const memorizedSearch = (0, react_1.useCallback)((0, lodash_1.debounce)(search, 250), []);
    return [memorizedSearch, selectableOptions];
};
exports.default = useSearch;
